/**
 * PLEASE do not use Mixins anymore,
 * If you are going to add a new method in this mixin consider UPGRADE THIS CODE to a high order component
 *
 */
const ReactGridDialogMixin = {
    _composite: function (obj) {
        for (var prop in this) {
            if (Object.prototype.hasOwnProperty.call(this, prop) && (prop.charAt(0) !== '_')) {
                obj[prop] = this[prop];
            }
        }
        return obj;
    },
    // todo: Make global.
    openDialog: function(title, body, customButtons){
        var popupHolder = $('body');
        var popupId = "popup-alert-container-" + Math.random().toString(36).substring(7);

        popupHolder.append('<div id="'+popupId+'">'+body+'</div>');
        popupHolder.find('#'+popupId).dialog({
            title: title,
            resizable: false,
            minWidth: 450,
            minHeight: 220,
            height: 'auto',
            modal: true,
            dialogClass: 'modules-js-react-grid-dialog',
            buttons: customButtons,
            close: function( event, ui ) {
                $('#'+popupId).remove();
            }
        });
    },
}

class ReactGrid extends React.Component {
    constructor(props){
        super(props);
        this._initialLoad = true;
        this.defaultViewLoaded = false;
        this.requestParams = null;
        this.gridRootRef = React.createRef();

        ReactGridDialogMixin._composite(this);

        let sortedCols = this.sortAlwaysHiddenColumns(props.columns);
        let cols = new Columns({cols: Immutable.fromJS(sortedCols, ColumnsFromJS)});
        let sortCol = cols.getDefaultSort();
        if (sortCol && sortCol.get('ModuleConfigGridColumn') && sortCol.get('ModuleConfigGridColumn').get('is_not_sortable')) {
            sortCol = undefined;
        }
        if (sortCol && sortCol.get('is_multi')) {
            sortCol = undefined;
        }

        this.state = {
            needsLoad: false, // set to true to load the records (calls this.load() basically)
            records: Immutable.List(),
            recordIds: null,
            limit: props.limit ? props.limit : 25,
            total: 0,
            page: 1,
            selected: Immutable.OrderedMap(),
            colsToShow: 0, // this is without checkbox and name columns
            columns: cols,
            filters: new Filters({filters: Immutable.fromJS(props.filters, FiltersFromJS)}),
            query: '',
            sort_col: sortCol,
            sort_dir: sortCol ? sortCol.get('ModuleConfigGridColumn').get('sort_direction') : 'ASC',
            urlParams: {},
            customFilter: props.customFilter,
            saveViews: true,
            aggregates: props.aggregates,
        };
    }

    // https://facebook.github.io/react/docs/reusable-components.html

    sortAlwaysHiddenColumns(columns){
        let me = this;
        let cols = [];
        let hiddenCols = [];
        if(me.props.alwaysHiddenColumns.length){
            columns.forEach(function (column) {
                var columnFound = false;
                me.props.alwaysHiddenColumns.forEach(function(alwaysHiddenColumnAlias){
                    if(column.alias==alwaysHiddenColumnAlias){
                        columnFound = true;
                    }
                });

                if(columnFound){
                    hiddenCols.push(column);
                }else{
                    cols.push(column);
                }
            })

            return cols.concat(hiddenCols);
        }else{
            return columns;
        }
    }
    componentDidUpdate() {
        //console.log('componentDidUpdate');
        if (this.state.needsLoad) {
            this.load();
        }
        $('[data-toggle="tooltip"]').tooltip();
    }
    componentDidMount() {

        let timer = 0;
        let me = this;
        $(window).on('resize.ReactGrid', function() {
            if(timer) {
                window.clearInterval(timer);
            }
            timer = window.setTimeout(function(){
                me.handleResize();
            }, 10);
        });
        this.handleResize();
        this.load();

        $('body').on('click', function (e) {
            $('[data-toggle="tooltip"]').each(function () {
                //the 'is' for buttons that trigger popups
                //the 'has' for icons within a button that triggers a popup
                if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.tooltip').has(e.target).length === 0) {
                    $(this).tooltip('hide');
                }
            });
        });

        //var cols = this.state.columns.setColumnVisibility("6", true);
        //console.log(cols == this.state.columns, cols === this.state.columns, this.state.columns.get('cols').toString());
        //this.state.columns = cols;
        //cols = this.state.columns.setColumnVisibility("6", true);
        //console.log(cols == this.state.columns, cols === this.state.columns, this.state.columns.get('cols').toString());
    }
    componentWillUnmount() {
        $(window).off('resize.ReactGrid');
    }
    handleResize() {
        var w = this.gridRootRef.current.offsetWidth;
        var numColsToShow = 6; // this is without checkbox and name columns

        // Calculate num of columns to show based on grid width
        if (w <= 1680) {
            numColsToShow = 5;
        }
        if (w <= 1500) {
            numColsToShow = 4;
        }
        if (w <= 1290) {
            numColsToShow = 3;
        }
        if (w <= 970) {
            numColsToShow = 2;
        }
        if (w <= 760) {
            numColsToShow = 1;
        }
        if (w <= 550) {
            numColsToShow = 0;
        }
        this.setState({colsToShow: numColsToShow});
    }
    toggleColumns(e) {
        // todo: this is a hack - should be handled by react
        $(e.target).closest('.grid-row.has-pushed-cols').toggleClass('expanded');
    }
    getAggregateValue(aggregateId){
        var value = null;
        if(this.state.aggregateData){

            this.state.aggregateData.forEach(function(aggregate){
                if(aggregate.id == aggregateId){
                    value = aggregate.value;
                }
            })

        }
        return value;
    }
    select(id, e) {
        var sel = this.state.selected;
        if (e.target.checked) {
            // Maintain order of selected items as is in grid
            var newSelection = Immutable.OrderedMap();

            this.state.records.forEach(function (r) {
                if (r.getIn(this.props.idPath) == id || sel.get(r.getIn(this.props.idPath))) {
                    newSelection = newSelection.set(r.getIn(this.props.idPath), r.getIn(this.props.idPath));
                }
            }.bind(this));

            this.setState({selected: newSelection});
            return;
        } else {
            sel = sel.delete(id);
        }
        this.setState({selected: sel});
    }
    selectAll(e) {
        if (e.target.checked) {
            // Maintain order of selected items as is in grid
            var newSelection = Immutable.OrderedMap();

            this.state.records.forEach(function(r) {
                newSelection = newSelection.set(r.getIn(this.props.idPath), r.getIn(this.props.idPath));
            }.bind(this));

            this.setState({selected: newSelection});
        } else {
            var sel = this.state.selected;
            sel = sel.clear();
            this.setState({selected: sel});
        }
    }
    /**
     * Returns a two-element array containing:
     *
     *   1. the react event
     *   2. an array with the person ids
     *
     * @returns []
     * @private
     */
    _normalizeUserActionArgs() {
        var ids = [], e;
        if (arguments[0] instanceof Array) {
            e = arguments[1];
            ids = arguments[0];
        } else {
            e = arguments[0];
            ids = this.state.selected.toArray();
        }
        return [e, ids];
    }
    expandIdPath(path,obj,value){
        var item = path.shift();
        if(path.length===0){
            obj[item] = value;
        }else{
            obj[item] = {};
            this.expandIdPath(path,obj[item],value)
        }
    }
    exportPDF() {
        var args = this._normalizeUserActionArgs.apply(this, arguments),
            e = args[0],
            ids = args[1];
        var url = this.props.export_pdf_url;
        var idProps = {};
        this.expandIdPath(this.props.idPath.slice(),idProps,ids);
        var firstChar = url.indexOf('?') == -1 ? '?' : '&';
        url += firstChar + 'module_item_id=' + this.props.module_item_id;
        url += '&_moduleToken=' + this.props.module_item_token;
        url += '&' + $.param(idProps);
        url += '&' + $.param({filters: this.getFiltersValues()});
        url += '&' + $.param({search: this.state.query});
        window.open(url, '_blank');
    }
    customPrintActionPDF() {
        var args = this._normalizeUserActionArgs.apply(this, arguments),
            e = args[0],
            ids = args[1];
        var url = this.props.custom_print_action_url;
        var firstChar = url.indexOf('?') == -1 ? '?' : '&';
        url += firstChar + 'person_ids[]=' + ids.join('&person_ids[]=');
        window.open(url, '_blank');
    }

    downloadPDF() {
        var args = this._normalizeUserActionArgs.apply(this, arguments),
            e = args[0],
            ids = args[1];
        var url = this.props.export_pdf_url;
        var idProps = {};
        this.expandIdPath(this.props.idPath.slice(),idProps,ids);
        var firstChar = url.indexOf('?') == -1 ? '?' : '&';
        url += firstChar+'module_item_id=' + this.props.module_item_id;
        url += '&_moduleToken=' + this.props.module_item_token;
        url += '&' + $.param(idProps);
        url += '&' + $.param({filters: this.getFiltersValues()});
        url += '&' + $.param({search: this.state.query});
        url += '&download=true';
        window.open(url, '_blank');
    }
    /**
     * Exports selected records
     */
    exportCSV() {
        var args = this._normalizeUserActionArgs.apply(this, arguments),
            e = args[0],
            ids = args[1];
        var url = this.props.export_csv_url;
        var idProps = {};
        this.expandIdPath(this.props.idPath.slice(),idProps,ids);
        var firstChar = url.indexOf('?') == -1 ? '?' : '&';
        url += firstChar+'module_item_id=' + this.props.module_item_id;
        url += '&_moduleToken=' + this.props.module_item_token;
        url += '&' + $.param(idProps);
        url += '&' + $.param({filters: this.getFiltersValues()});
        if(this.props.moduleSettings && this.props.moduleSettings.export_visible_columns_csv=='1') {
            url += '&' + $.param({columns: this.getColumnAliases()});
        }
        url += '&' + $.param({search: this.state.query});
        url += '&sort=' + (this.state.sort_col ? this.state.sort_col.get('ModuleConfigGridColumn').get('field') : '');
        url += '&dir=' + this.state.sort_dir;
        window.open(url, '_blank');
    }
    /**
     * Exports selected records
     */
    exportAllToCSV() {
        var url = this.props.export_all_csv_url;
        var firstChar = url.indexOf('?') == -1 ? '?' : '&';
        url += firstChar+'module_item_id=' + this.props.module_item_id;
        url += '&_moduleToken=' + this.props.module_item_token;
        url += '&' + $.param({filters: this.getFiltersValues()});
        url += '&' + $.param({columns: this.getColumnAliases()});
        url += '&' + $.param({search: this.state.query});
        url += '&sort=' + (this.state.sort_col ? this.state.sort_col.get('ModuleConfigGridColumn').get('field') : '');
        url += '&dir=' + this.state.sort_dir;
        window.open(url, '_blank');
    }

    /**
     * Shows dialog to export records to mailchimp
     */
    showMailchimpLists() {
        var me = this;
        var args = this._normalizeUserActionArgs.apply(this, arguments),
            e = args[0],
            ids = args[1];

        var method = e.target.getAttribute("method");
        var personIds = this.getSelectedPersonIds(ids);
        /** @property ReactMailchimpList ReactMailchimpList*/
        var ReactMailchimpList = this.refs.mailchimp_list;

        var advancedQuery = {
            module_item_id: this.props.module_item_id,
            filters: this.getFiltersValues(),
            columns: this.getColumnAliases(),
            search: this.state.query,
            method:method
        };

        $.get(SS.route('Mailchimp', 'Mailchimp', 'getLists', null),function(mailchimpResponse){
            ReactMailchimpList.show(personIds,mailchimpResponse,advancedQuery);
        });

    }

    /**
     * Shows bulk update options (for now we have record types)
     */
    showBulkEditOptions() {
        let args = this._normalizeUserActionArgs.apply(this, arguments),
            e = args[0],
            ids = args[1];

        let method = e.target.getAttribute("method");
        let personIds = this.getSelectedPersonIds(ids);
        /** @property ReactBulkEdit ReactBulkEdit*/
        let ReactBulkEdit = this.refs.bulk_edit_ref;

        let advancedQuery = {
            module_item_id: this.props.module_item_id,
            filters: this.getFiltersValues(),
            columns: this.getColumnAliases(),
            search: this.state.query,
            method: method
        };
        ReactBulkEdit.show(personIds, advancedQuery);
    }

    /**
     * Exports all records currently in grid (not just on current page)
     */
    exportCurrentCSV() {
        var url = this.props.export_current_csv_url;
        var firstChar = url.indexOf('?') == -1 ? '?' : '&';
        url += firstChar+'module_item_id=' + this.props.module_item_id;
        url += '&_moduleToken=' + this.props.module_item_token;
        url += '&' + $.param({recordIds: this.state.recordIds});
        url += '&' + $.param({columns: this.getColumnAliases()});
        window.open(url, '_blank');
    }
    sendMessage() {
        var args = this._normalizeUserActionArgs.apply(this, arguments),
            e = args[0],
            ids = args[1];
        var personIds = this.getSelectedPersonIds(ids);

        var sendMessageSubject = null;
        if(this.props.sendMessageSubjectPath && this.state.selected.size === 1) {
            sendMessageSubject = this.state.records.first().getIn(this.props.sendMessageSubjectPath);
        }

        if(personIds.length){
            this.refs.send_message.show(personIds, sendMessageSubject);
        }
    }
    createRecord() {
        this.refs.create_record.show();
    }
    getSelectedPersonIds(ids){
        var personIds = [];
        ids.forEach(function(id){
            var r = this.state.records.find(function(value){
                return value.getIn(this.props.idPath)==id
            }.bind(this));
            var personId = r.getIn(this.props.personIdPath);
            if(personId && personIds.indexOf(personId)<0){
                personIds.push(personId);
            }
        }.bind(this))
        return personIds;
    }
    getTotalSelectedPersonIds(){
        return this.getSelectedPersonIds(this.state.selected.toArray()).length;
    }
    getSelectedBulkActions(ids,conditions){
        var actions = [];
        ids.forEach(function(id){
            var r = this.state.records.find(function(value){
                return value.getIn(this.props.idPath)==id
            }.bind(this));
            if(conditions(r)){
                actions.push(r);
            }
        }.bind(this))
        return actions;
    }
    getTotalSelectedBulkActions(conditions){
        return this.getSelectedBulkActions(this.state.selected.toArray(),conditions).length;
    }
    editRecord() {
        var args = this._normalizeUserActionArgs.apply(this, arguments),
            e = args[0],
            ids = args[1];

        this.refs.edit_record.edit(ids);
    }
    deleteRecord() {
        var args = this._normalizeUserActionArgs.apply(this, arguments),
            e = args[0],
            ids = args[1];

        var me = this;
        var title = 'Delete confirmation';
        var text = 'Are you sure you want to delete this?';
        var customButtons =  {
            Remove: function() {

                $.ajax({
                    url: me.props.delete_url,
                    data: {
                        id: ids
                    },
                    dataType: 'json',
                    cache: false,
                    success: function(data) {
                        //console.log(data, Immutable.fromJS(data[data.metaData.root]));
                        me.setState({
                            needsLoad: true
                        });
                    }.bind(this),
                    error: function(xhr, status, err) {
                        alert(xhr.responseText);
                    }
                });

                $(this).dialog("close");
            },
            Cancel: function() {
                $(this).dialog("close");
            }
        };

        this.openDialog(title, text, customButtons);

    }
    maxPage(limit, total) {
        return Math.ceil(total/limit);
    }
    hasPrev(limit, total) {
        return this.state.page -1 >= 1;
    }
    hasNext(limit, total) {
        return this.state.page + 1 <= this.maxPage(limit, total);
    }
    prev() {
        var state = this.state;
        if (this.hasPrev(state.limit, state.total)) {
            this.setState({
                needsLoad: true,
                selected: Immutable.Map(),
                page: state.page-1
            });
        }
    }
    next() {
        var state = this.state;
        if (this.hasNext(state.limit, state.total)) {
            this.setState({
                needsLoad: true,
                selected: Immutable.Map(),
                page: state.page+1
            });
        }
    }

    load() {
        var urlParams = this.props.urlParams;

        if(this.hasDefaultView() && !this.defaultViewLoaded){
            this.setOriginalViewData();
            return;
        }

        if(this._initialLoad){
            this._initialLoad = false;

            if(this.state.customFilter){
                this.setCustomFilter(this.state.customFilter,true);
                return;
            }

        }

        var queryParams = {
            sort: this.state.sort_col? this.state.sort_col.get('ModuleConfigGridColumn').get('field'):undefined,
            dir: this.state.sort_dir,
            limit: this.state.limit,
            page: this.state.page,
            module_item_id: this.props.module_item_id,
            _moduleToken: this.props.module_item_token,
            filters: this.getFiltersValues()
        };
        if(this.state.query){
            queryParams[this.props.searchParam] = this.state.query;
        }
        $.extend(queryParams,urlParams);

        if(this.state.customFilter && this.state.customFilter.params){
            $.extend(queryParams,this.state.customFilter.params);
        }

        this.setState({
            loading:true,
            needsLoad: false
        });

        this.requestParams = queryParams;

        $.ajax({
            url: this.props.load_url,
            data: queryParams,
            dataType: 'json',
            cache: false,
            success: function(data) {
                //console.log(data, Immutable.fromJS(data[data.metaData.root]));

                this.setState({
                    loading:false,
                    needsLoad: false,
                    records: Immutable.fromJS(data[data.metaData.root]),
                    recordIds: data.recordIds && data.recordIds.length > 0 ? data.recordIds : null,
                    selected: Immutable.Map(),
                    currentQuery:queryParams,
                    total: data.total,
                    aggregateData: data.aggregates?data.aggregates:[]
                });
            }.bind(this),
            error: function(xhr, status, err) {
                alert('An Error occurred');
            }
        })
    }
    search(e, ev) {
        if (e.which == 13) { // search on ENTER
            this.setState({
                needsLoad: true,
                query: e.target.value,
                selected: Immutable.Map(),
                page: 1
            });
        }

        this.updateSearchField(e.target.value, e.target.parentElement);
    }
    clearSearch(e) {
        this.setState({
            needsLoad: true,
            query: null,
            selected: Immutable.Map(),
            page: 1
        });

        this.updateSearchField(null, e.target.parentElement);
    }
    updateSearchField(value, parent) {
        // todo: do this with react
        if(value && value.length > 0){
            $(parent).addClass('with-value');
        } else {
            $(parent).removeClass('with-value');

            $(this.refs.search_field).val("");
        }
    }
    changeLimit(e) {
        var lim = parseInt(e.target.innerHTML);
        if (lim && this.state.limit != lim) {
            this.setState({
                needsLoad: true,
                limit: lim,
                selected: Immutable.Map(),
                page: Math.min(this.state.page, this.maxPage(lim, this.state.total))
            });
        }
    }
    toggleFilters() {
        // todo: this is a hack - should be handled by react
        // maybe take a look at https://facebook.github.io/react/docs/animation.html
        $(ReactDOM.findDOMNode(this)).find('.grid-filters').slideToggle();
        $(ReactDOM.findDOMNode(this)).find('.toggle-filters').toggleClass('hidden');
    }
    toggleColumnVisibility(id, e) {
        var state = this.state;
        var col = state.columns.get('cols').get(id);
        var columns = this.state.columns.setColumnVisibility(id, !col.isHidden());
        this.setState({columns: columns});
    }
    getColumnAliases() {
        var cols = {};
        this.state.columns.get('cols').forEach(function(c) {
            if (!c.isHidden()) {
                cols[c.get('alias')] = c.getIn(['ModuleConfigGridColumn', 'label']);
            }
        }.bind(this));
        return cols;
    }
    forEachFilter(cb) {
        this.state.filters.get('filters').forEach(function(f) {
            if (!f.isHidden()) {
                return cb(f);
            }
        });
    }
    getFiltersValues() {
        var vals = {};
        var id, ref;
        this.forEachFilter(function(f) {
            id = f.get('ModuleConfigGridFilter').get('id');
            if (ref = this.refs['filter_'+id]) {
                vals[id] = ref.getValues();
            }
        }.bind(this));

        try{
            var uriData = URI.parse(window.location.href);

            if(uriData.query){
                var query = URI.parseQuery(uriData.query);
                var keys = Object.keys(query);

                keys.forEach(function(key){
                    if(key.indexOf('filters[')>=0){
                        var filter = this._addFilterKeyToObject(key,query[key]);

                        vals = $.extend(vals,filter);
                    }
                }.bind(this))
            }

        }catch(e){}

        return vals;
    }
    _addFilterKeyToObject(path,value){
        path = path.split('[');

        var pathsCorrected = [];

        path.forEach(function(key){
            key = key.replace("]","")
            pathsCorrected.push(key);
        })
        pathsCorrected.reverse();
        var obj = value;


        pathsCorrected.forEach(function(path){
            var newObj = {};
            newObj[path] = obj;
            obj = newObj;
        })

        obj = obj.filters;

        return obj;

    }
    applyFilters() {
        this.load();
    }
    setCustomFilter(filter,clear){
        if(clear){
            var id, ref;
            this.forEachFilter(function(f) {
                id = f.get('ModuleConfigGridFilter').get('id');
                if (ref = this.refs['filter_'+id]) {
                    ref.clearValues();
                }
            }.bind(this));
        }

        this.setState({
            customFilter:filter
        },function(){
            setTimeout( function(){
                this.load();
            }.bind(this)  , 50 );
        }.bind(this));
    }
    removeCustomFilter(){
        this.setState({
            customFilter:undefined
        },function(){
            this.load();
        }.bind(this));
    }
    clearFilters() {
        var id, ref;
        this.forEachFilter(function(f) {
            id = f.get('ModuleConfigGridFilter').get('id');
            if (ref = this.refs['filter_'+id]) {
                ref.clearValues();
            }
        }.bind(this));


        setTimeout( function(){
            this.load();
        }.bind(this)  , 50 ); //not sure why but necessary, Erol: I guess it takes a bit of time to clear filters and get

        if(this.refs.savedViews){
            this.refs.savedViews.clearView(true);
        }
    }
    changeSortCol(colId) {
        var col = this.state.columns.get('cols').get(colId);
        if (col != this.state.sort_col) {
            this.setState({
                needsLoad: true,
                selected: Immutable.Map(),
                sort_col: col
            });
        }
    }
    toggleSortDir() {
        this.setState({
            needsLoad: true,
            selected: Immutable.Map(),
            sort_dir: this.state.sort_dir=='ASC'?'DESC':'ASC'
        });
    }
    onToolClick(record,event){
        var $toolButton = $(event.target).closest('.tool');
        var toolName = $toolButton.data('tool');
        var component = this.refs['tool_'+toolName];
        if(component){
            component.initTool({
                target:$toolButton,
                record:record[0],
                main:this
            });
        }
    }
    onActionClick(action,record,event){
        var actionItem = this.props.actions[action];
        if(actionItem.handler){
            var args = record;
            if(actionItem.idPath){
                args = record.getIn(actionItem.idPath);
            }

            this.setState({
                loading:true,
                needsLoad: false
            },function(){
                actionItem.handler.call(this,args,function(){
                    this.setState({
                        loading:false,
                        needsLoad: false
                    })
                }.bind(this),{
                    container:this,
                    currentQuery:this.state.currentQuery
                });
            });

        }
    }
    onCustomActionClick(index, record, action, event) {
        this.setState({
            loading: true,
            needsLoad: false
        }, function () {
            action.handler(index, record, () => {
                this.setState({
                    loading: false,
                    needsLoad: false
                })
            }, {
                gridComponent: this,
                currentQuery: this.state.currentQuery
            }, event);
        });
    }
    onBulkActionClick(bulkAction){
        var bulkActionItem = this.props.bulkActions[bulkAction];
        var selectedActions = this.getSelectedBulkActions(this.state.selected.toArray(),bulkActionItem.conditions);
        if(selectedActions.length && bulkActionItem.handler){
            var args = selectedActions;
            if(bulkActionItem.idPath){
                var actionIds = [];
                selectedActions.forEach(function(selectedAction){
                    actionIds.push(selectedAction.getIn(bulkActionItem.idPath))
                })
                args = actionIds;
            }
            if(args){
                this.setState({
                    loading:true,
                    needsLoad: false
                },function(){
                    bulkActionItem.handler.call(this,args,function(){
                        this.setState({
                            loading:false,
                            needsLoad: false
                        })
                    }.bind(this),{
                        container:this,
                        currentQuery:this.state.currentQuery
                    });
                });
            }

        }
    }
    onBulkCustomActionClick(index, records, action, event){
        this.setState({
            loading: true,
            needsLoad: false
        }, function () {
            action.bulkHandler(index, records, () => {
                this.setState({
                    loading: false,
                    needsLoad: false
                })
            }, {
                gridComponent: this,
                currentQuery: this.state.currentQuery
            }, event);
        });
    }
    getURLForColumn(column, record) {
        var link_identifier = column.getIn(['ModuleConfigGridColumn', 'link_identifier']);
        var link = this.props.links[link_identifier];
        if (link) {
            var url = link[0];
            var p, v;
            for (var i=0; i<link.length-1; i++) {
                p = link[i+1];
                v = record.getIn(p, null);
                if (v === null) {
                    return null;
                }
                if(typeof url == 'string')
                    url = url.replace('{'+i+'}', v);
            }
            return url;
        }
        return null;
    }
    addCustomComponent(cmp,callback){
        var props = this.props;
        var state = this.state;
        var customComponents = state.customComponents?state.customComponents:[];
        if(!this.refs[cmp.ref]){
            customComponents.push(cmp)
        }
        this.setState({
            customComponents:customComponents
        },callback)
    }
    onActionsClick(r, event) {
        var open = event.currentTarget.classList.contains('open');
        for (var i in this.props.actions) {
            if (this.props.actions.hasOwnProperty(i)) {
                var action = this.props.actions[i];
                if (action.onToggle) {
                    action.onToggle(open, this, r);
                }
            }
        }
        if(this.props.customActions){
            this.props.customActions.forEach((action, index) => {
                action.onToggle(open, r, this);
            })
        }
    }
    hasDefaultView(){
        var hasDefaultView = false;

        this.state.filters.get('filters').forEach(function(f) {
            if (!f.isHidden()) {
                hasDefaultView = true;
            }
        })

        return hasDefaultView;
    }
    loadDefaultView(view){
        this.defaultViewLoaded = true;
        if(view){
            this.applyViewData(view);
        }else{
            this.load();
        }
    }
    getViewData() {
        return {
            filter: this.getFiltersValues(),
            shownColumns:this.getVisibleColumns(),
            sortColumn:this.state.sort_col?this.state.sort_col.getIn(['ModuleConfigGridColumn','id']):undefined,
            sortDirection:this.state.sort_dir
        }
    }
    resetView(){
        this.refs.savedViews.clearView(true);
        this.applyViewData(this.originalViewData);
    }
    setOriginalViewData(){
        this.originalViewData = this.getViewData();
    }
    applyViewData(data){
        var state = {
            needsLoad: true
        }

        var columns = this.state.columns;

        if(data.shownColumns && data.shownColumns.length){

            columns.get('cols').forEach(function(c, colId) {
                if(data.shownColumns.indexOf(colId)>=0){
                    columns = columns.setColumnVisibility(colId, false)
                }else{
                    columns = columns.setColumnVisibility(colId, true)
                }
            })
        }

        if(data.sortColumn){
            var sortCol = columns.get('cols').get(data.sortColumn);
            if(sortCol){
                state.sort_col = sortCol;
            }

        }else{
            state.sort_col = undefined;
        }

        if(data.sortDirection){
            state.sort_dir = data.sortDirection;
        }

        this.forEachFilter(function(f) {
            var filterId = f.get('ModuleConfigGridFilter').get('id');
            var ref = this.refs['filter_'+filterId];


            if(!data.filter[filterId]){
                if (ref) {
                    ref.clearValues();
                }
            }else{
                var values = data.filter[filterId];
                if(ref && ref.setValues){
                    ref.setValues(values);
                }
            }

        }.bind(this));

        state.columns = columns;

        this.setState(state)
    }
    getVisibleColumns(){
        var columns = [];
        this.state.columns.get('cols').forEach(function(c, id) {
            if(!c.isHidden()){
                columns.push(c.getIn(['ModuleConfigGridColumn','id']));
            }
        })
        return columns;
    }
    toggleMap() {
        $(ReactDOM.findDOMNode(this.refs.map_view)).slideToggle();

        $(ReactDOM.findDOMNode($('.grid-holder')[0])).slideToggle();

        $(ReactDOM.findDOMNode(this)).find('.btn.toggle-map').toggleClass('hidden');
    }
    render() {

        var props = this.props;
        var state = this.state;
        var rows = [];
        var page = state.page;
        var avlCols = [];
        var colHeaders = [];
        var sortCols = [];
        var filters = [];
        var hideableCols = 0;
        var hasAlwaysHiddenCols = false;
        var hasExpanedCols = false;
        var me = this;

        var bulkActions = [];
        var bulkActionComponents = [];
        if(props.bulkActions){
            var keys = Object.keys(props.bulkActions);
            var bulkAction = {};
            keys.forEach(function(key){
                bulkAction = props.bulkActions[key];

                var itemCount = 0;
                if(typeof bulkAction.conditions == 'function'){
                    itemCount = me.getTotalSelectedBulkActions(bulkAction.conditions);
                }

                bulkActions.push(
                    <a key={'bulkAction'+key} onClick={me.onBulkActionClick.bind(me,key)} className={"dropdown-item" + (itemCount==0 ? ' disabled' : '')}>{bulkAction.text}{itemCount>=0? ' ('+itemCount+')':undefined}</a>
                )

                if(bulkAction.component){
                    bulkActionComponents.push(
                        React.createElement(bulkAction.component,{
                            key:'bulk_action_component_'+key,
                            module_item_id:this.props.module_item_id,
                            ref:'bluk_action_component_'+key,
                            container:this
                        })
                    )
                }
            }.bind(this))
        }
        if(props.customActions){
            props.customActions.forEach((action, index) => {
                if(!action.allowBulk()){
                    return;
                }
                var selectedRecords = [];
                var itemsCount = 0;
                this.state.selected.toArray().forEach((id) => {
                    var record = this.state.records.find((record) => {
                        return record.getIn(this.props.idPath) == id
                    });
                    if(action.conditions(record)) {
                        selectedRecords.push(record);
                        itemsCount++;
                    }
                });

                bulkActions.push(
                    <a
                        key={'bulkAction' + index}
                        onClick={me.onBulkCustomActionClick.bind(me, index, selectedRecords, action)}
                        className={"dropdown-item" + (itemsCount == 0 ? ' disabled' : '')}
                        dangerouslySetInnerHTML={{__html: action.getText() + (itemsCount >= 0 ? ' (' + itemsCount + ')' : undefined)}}
                    />
                )
            });
        }

        var hasBulkActions = props.export_pdf_url || props.export_pdf_url || props.export_csv_url ||
            props.showSendMessage && props.personIdPath ||
            props.delete_url || bulkActions.length;

        state.columns.get('cols').forEach(function(c, id) {

            var readonly = avlCols.length === 0; // first column is always the most important
            avlCols.push(
                <div key={'col'+c.getIn(['ModuleConfigGridColumn','id'])} className={'checkbox-holder checkbox-holder-'+c.get('alias')}>
                    <label className={'c-input c-checkbox' + (readonly?' disabled':'')}>
                        <input
                            onChange={this.toggleColumnVisibility.bind(this, id)}
                            checked={!c.isHidden()}
                            disabled={readonly}
                            type="checkbox"/>
                        <span className="c-indicator"/>
                        <span className="c-label">{c.getIn(['ModuleConfigGridColumn', 'label'])}</span>
                    </label>
                </div>
            );

            if(!c.getIn(['ModuleConfigGridColumn','is_not_sortable']) && !c.get('is_multi')) {

                sortCols.push(
                    <a
                        onClick={this.changeSortCol.bind(this, id)}
                        key={'col'+c.getIn(['ModuleConfigGridColumn','id'])} className="dropdown-item">
                        {c.getIn(['ModuleConfigGridColumn', 'label'])}
                    </a>
                );
            }

            if (!c.isHidden()) {
                var isHiddenColumn = false;
                if(props.alwaysHiddenColumns.length && props.alwaysHiddenColumns.indexOf(c.getIn(['alias']))>-1){
                    isHiddenColumn = true;
                }

                if(c.getIn(['ModuleConfigGridColumn','expanded_field'])){
                    isHiddenColumn = true;
                }

                if(!isHiddenColumn) {
                    var cls = ['grid-col grid-col-normal'];
                    if (colHeaders.length === 0) {
                        // todo: is the first column the most important?
                        cls.push('always-visible-col');
                    } else {
                        hideableCols++;
                    }
                    if (state.colsToShow >= hideableCols) {
                        colHeaders.push(
                            <div key={'col' + c.getIn(['ModuleConfigGridColumn', 'id']).replace(/\./, '')}
                                 className={cls.join(' ')}>
                                <div className="grid-cell-value">{c.getIn(['ModuleConfigGridColumn', 'label'])}</div>
                            </div>
                        );
                    }
                }
            }

            // todo: Check if it's ok to always put in 2nd place
            if(props.tools && colHeaders.length === 1){
                colHeaders.push(<div className="grid-col grid-col-tool-header" key={'tool-header-'+c.getIn(['ModuleConfigGridColumn','id']).replace(/\./, '')} ref="grid_col_tools_header">
                    <div className="grid-cell-value">&nbsp;</div>
                </div>);
            }

        }.bind(this));

        var canBulkDelete = true;

        state.records.forEach(function(r) {
            var id = 'grid-row-' + r.getIn(props.idPath);
            var cols = [];
            hideableCols = 0;
            state.columns.get('cols').forEach(function(c, key, arr) {
                if (c.isHidden()) {
                    return;
                }
                var cls = [];
                if (cols.length === 0) {
                    // todo: is the first column the most important?
                    cls.push('always-visible-col');
                } else {
                    hideableCols++;
                }
                if(props.alwaysHiddenColumns.length && props.alwaysHiddenColumns.indexOf(c.getIn(['alias']))>-1){
                    cls.push('pushed-col');
                    hasAlwaysHiddenCols = true;
                }else if (c.getIn(['ModuleConfigGridColumn','expanded_field'])) {
                    cls.push('pushed-col');
                }else if (state.colsToShow < hideableCols) {
                    cls.push('pushed-col');
                }else {
                    cls.push('not-pushed-col');
                }

                if(c.getIn(['ModuleConfigGridColumn','expanded_field'])){
                    hasExpanedCols = true;
                }

                var aliasSlug = c.get('alias').replace(/\./, '');

                var val = r.getIn(c.get('alias').split('.'));

                if (props.columnRenderers[c.get('alias')]) {
                    val = props.columnRenderers[c.get('alias')](val, r);
                }

                if (val !== null) {

                    var fieldFormatComp = false;
                    var fieldFormatProps = [];
                    var isSafari = navigator.userAgent.toLowerCase().indexOf('safari/') > -1;
                    var dateVal = val;
                    if(isSafari && typeof(val) == 'string' ){
                        dateVal = val.replace(/-/g, "/");
                    }


                    var dateTest = /^([0-9]{2,4})-([0-1][0-9])-([0-3][0-9])(?:( [0-2][0-9]):([0-5][0-9]):([0-5][0-9]))?$/
                    // If it's date
                    if(val && val !== true && val.match && val.match(dateTest) && new Date(dateVal) !== "Invalid Date" && !isNaN(new Date(dateVal))) {
                        fieldFormatComp = "ReactIntl.FormattedDate";

                        fieldFormatProps['day'] = 'numeric';
                        fieldFormatProps['month'] = 'short';
                        fieldFormatProps['year'] = 'numeric';
                        val = dateVal;
                    }

                    // If field has formatting passed
                    if (c.getIn(['formatted', 'component'])) {
                        fieldFormatComp = c.getIn(['formatted', 'component']);
                        fieldFormatProps = c.getIn(['formatted', 'props']).toJS() ? c.getIn(['formatted', 'props']).toJS() : [];
                    }

                    if (fieldFormatComp) {
                        // apply custom formatting, if specified

                        // Safari doesn't understand new Date('2015-11-24 12:58:01') so we need
                        // to convert it to ISO format '2015-11-24T12:58:01'
                        var matches;
                        if (typeof(val) == 'string' && fieldFormatComp == 'ReactIntl.FormattedDate') {
                            if((matches = val.match(/(^\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}:\d{2}.*)/))){
                                val = matches[1] + 'T' + matches[2];
                            }else if(val.match(/(^\d{4}-\d{2}-\d{2})/)){ //if it's a date
                                val = val+'T'+'00:00:00'
                            }

                            var b = val.split(/\D/);
                            if(!b[3] && !b[4] && !b[5]){
                                b[3] = '00';
                                b[4] = '00';
                                b[5] = '00';
                            }
                            val= new Date(b[0], b[1]-1, b[2], b[3], b[4], b[5]);
                        }

                        val = React.createElement(eval(fieldFormatComp), $.extend(fieldFormatProps, {
                            value: val,
                            record: r,
                            grid: this,
                            column: c
                        }));
                    }else if(props.renderHtmlColumns.length && props.renderHtmlColumns.indexOf(c.getIn(['alias']))>-1){
                        val = <div dangerouslySetInnerHTML={{__html: val}} />;
                    }
                } else {
                    val = <span className="empty-value">-</span>;
                }

                var url;
                if (!c.get('customLink') && (url = this.getURLForColumn(c, r))) {
                    if($.isFunction(url)){
                        val = <a href="#" onClick={preventDef(url.bind(this,r))}>{val}</a>
                    }else {
                        val =
                            <a href={url}>
                                {val}
                            </a>
                    }
                }

                var tools = [];
                var emptyTools = [];
                if(props.tools && cols.length === props.linkColumn){
                    var keys = Object.keys(props.tools);
                    var tool = {};
                    keys.forEach(function(key){
                        tool = props.tools[key];
                        if(tool.conditions(r)){
                            tools.push(
                                <span onClick={me.onToolClick.bind(me, [r])} data-tool={key} key={'tool_'+key} className="tool">
                                    {tool.html}
                                </span>
                            );
                        }else{
                            emptyTools.push(<span key={'tool_'+key} />);
                        }
                    })
                }
                //tools = tools.concat(emptyTools);



                var label = c.get('ModuleConfigGridColumn').get('label');

                if (props.labelRenderers[c.get('alias')]) {
                    label = props.labelRenderers[c.get('alias')](label, r);
                }

                var valText = null;
                if(typeof val=='string'){
                    valText = val;
                }

                cols.push(
                    <div
                        key={'col-'+c.getIn(['ModuleConfigGridColumn','id'])}
                        className={'grid-col grid-col-normal grid-col-'+aliasSlug+' '+cls.join(' ')}
                        data-col-alias={aliasSlug}
                    >
                        <div className="grid-cell-value row-eq-height" data-toggle="tooltip" data-placement="bottom" data-trigger="click" title={valText}>
                            {val}
                        </div>

                        <div className="grid-cell-subtitle row-eq-height">
                            {label}
                        </div>
                    </div>
                );

                var extraCols = [];


                tools.forEach(function(tool,index){
                    if(index === 0) {
                        extraCols.push(<div key={'tool-' + index} className="grid-col-tool">{tool}</div>)
                    }
                })

                if(extraCols.length){
                    cols.push(<div key={"col-tool-wrap-"+r.getIn(props.idPath)} className="tool-wrap grid-col grid-col-tools">{extraCols}</div> );
                }

            }.bind(this));

            var actions = [];
            if(props.actions){
                var keys = Object.keys(props.actions);
                var action = {};
                var stateAction;
                var disabled = false;
                var text;
                keys.forEach(function(key){
                    action = props.actions[key];
                    stateAction = state['action_'+key] ? state['action_'+key][r.getIn(props.idPath)] || {} : {};
                    text = typeof(stateAction.text) != 'undefined' ? stateAction.text : action.text;
                    disabled = typeof(stateAction.disabled) != 'undefined' ? stateAction.disabled : action.disabled;
                    if(typeof action.conditions != 'function' || action.conditions(r)){
                        if (stateAction.link) {
                            actions.push(
                                <a className={'dropdown-item' + (disabled ? ' disabled' : '')} key={'action_' + key}
                                   data-action={key}
                                   href={stateAction.link.href} target={stateAction.link.target || '_self'}
                                   dangerouslySetInnerHTML={{__html: text}}/>
                            )
                        } else {
                            actions.push(
                                <a className={'dropdown-item' + (disabled ? ' disabled' : '')} key={'action_' + key}
                                   data-action={key}
                                   onClick={me.onActionClick.bind(me, key, r)}
                                   dangerouslySetInnerHTML={{__html: text}}/>
                            )
                        }
                    }

                })
            }

            if(props.customActions){
                props.customActions.forEach((action, index) => {
                    if(action.conditions(r)){
                        if(action.link.url){
                            actions.push(
                                <a
                                    className={'dropdown-item' + (action.isDisabled() ? ' disabled' : '')}
                                    key={'action_' + index}
                                    href={action.link.url} target={action.link.target}
                                    dangerouslySetInnerHTML={{__html: action.getText(r)}}
                                />
                            )
                        }else {
                            actions.push(
                                <a
                                    className={'dropdown-item' + (action.isDisabled() ? ' disabled' : '')}
                                    key={'action_' + index}
                                    onClick={this.onCustomActionClick.bind(this, index, r, action)}
                                    dangerouslySetInnerHTML={{__html: action.getText(r)}}
                                />
                            )
                        }
                    }
                });
            }

            var canDelete = true;
            var canUpdate = true;
            if(props.canDeletePath){
                var deleteAble = r.getIn(props.canDeletePath);
                if(typeof deleteAble === 'boolean'){
                    canDelete = deleteAble;
                }
            };

            if (state.selected.has(r.getIn(props.idPath))) {
                canBulkDelete = canBulkDelete && canDelete;
            }

            if(props.canUpdatePath){
                var updateAble = r.getIn(props.canUpdatePath);
                if(typeof updateAble === 'boolean'){
                    canUpdate = updateAble;
                }
            };

            var rowCls = '';
            if(this.props.getRowCls){
                rowCls = this.props.getRowCls(r);
            }

            rows.push(
                <div
                    className={'grid-row ' +rowCls + (state.colsToShow<hideableCols || hasAlwaysHiddenCols || hasExpanedCols?' has-pushed-cols':'')
                    +(hasBulkActions?' with-bulk-actions':' without-bulk-actions')
                    +(hasExpanedCols? ' expanded':'')}
                    id={id}
                    key={id}
                >
                    {hasBulkActions?
                        <div className="grid-col grid-col-checkbox">
                            <label className="c-input c-checkbox" id={'c-checkbox-' + r.getIn(props.idPath)}>
                                <input
                                    onChange={this.select.bind(this, r.getIn(props.idPath))}
                                    checked={state.selected.has(r.getIn(props.idPath))}
                                    type="checkbox"
                                />
                                <span className="c-indicator"/>
                                <span className="c-label"/>
                            </label>
                        </div>
                        :undefined}
                    <div className="grid-col grid-col-toggle" onClick={this.toggleColumns.bind(this)}>
                        <i className="toggle-icon icon-down"/>
                        <i className="toggle-icon icon-up"/>
                    </div>
                    {cols}
                    {props.export_pdf_url || props.custom_print_action_url || props.export_pdf_url || props.export_csv_url ||
                    props.showSendMessage && props.personIdPath && r.getIn(props.personIdPath) ||
                    props.delete_url || props.editComponent ||
                    actions.length ?
                        <div className="grid-col grid-col-actions">
                            <div className="btn-group grid-action" onClick={this.onActionsClick.bind(this, r)}>
                                <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <span>Actions</span>
                                </button>
                                <div className="dropdown-menu">
                                    {props.custom_print_action_url ? <a className="dropdown-item" onClick={this.customPrintActionPDF.bind(this, [r.getIn(props.idPath)])}>{props.custom_print_action_name}</a> : undefined}
                                    {props.export_pdf_url ? <a className="dropdown-item" onClick={this.exportPDF.bind(this, [r.getIn(props.idPath)])}>Export for Print</a> : undefined}
                                    {props.export_pdf_url ? <a className="dropdown-item" onClick={this.downloadPDF.bind(this, [r.getIn(props.idPath)])}>Export to PDF</a> : undefined}
                                    {props.export_csv_url ? <a className="dropdown-item" onClick={this.exportCSV.bind(this, [r.getIn(props.idPath)])}>Export to CSV</a> : undefined}
                                    {props.showSendMessage && props.personIdPath && r.getIn(props.personIdPath) ? <a className="dropdown-item" onClick={this.sendMessage.bind(this, [r.getIn(props.idPath)])}>Send Message</a> : undefined}
                                    {props.delete_url && canDelete ? <a className="dropdown-item" onClick={this.deleteRecord.bind(this, [r.getIn(props.idPath)])}>Delete</a> : undefined}
                                    {props.editComponent && canUpdate ? <a className="dropdown-item" onClick={this.editRecord.bind(this, [r.getIn(props.idPath)])}>Edit</a> : undefined}
                                    {actions}
                                </div>
                            </div>
                        </div>
                        :undefined}
                    <div className="clearfix"></div>
                </div>
            );
        }.bind(this));

        state.filters.get('filters').forEach(function(f) {
            if (f.isHidden()) {
                return;
            }

            var filterConfig = f.get('ModuleConfigGridFilter');

            //var filterClass = filterConfig.get('frontend');
            //if(filterConfig.get('plugin') =='Modules'){
            //filterClass = 'ReactFilter'+filterConfig.get('alias');
            //}

            var FilterClass = 'ReactFilter'+filterConfig.get('alias');

            /**
             * TODO: remove this eval and load clases with jsx <$FilterClass props... />
             */
            var filterElement = eval(FilterClass);

            filters.push(
                React.createElement(filterElement,{
                    key:'filter-id-'+filterConfig.get('id'),
                    ref:'filter_'+filterConfig.get('id'),
                    id:filterConfig.get('id'),
                    label:filterConfig.get('label'),
                    settings:filterConfig.get('settings') ? filterConfig.get('settings').toJS() : {},
                    applyFilters: me.applyFilters.bind(me),
                    clearFilters: me.clearFilters.bind(me),
                    loadGrid: me.load.bind(me)
                })
            );
        });

        var customFilter = undefined;
        if(this.state.customFilter){
            customFilter = <a href="#" onClick={preventDef(this.removeCustomFilter.bind(this))}><i/><span> {this.state.customFilter.text}</span></a>
        }
        var savedViews = null;

        if(this.state.saveViews){
            savedViews = <SavedViews
                ref = {"savedViews"}
                module_item_id = {this.props.module_item_id}
                grid = {this}
            />
        }

        var actionComponents = [];
        if(props.actions){
            var keys = Object.keys(props.actions);
            var action = {};
            keys.forEach(function(key){
                action = props.actions[key];
                if(action.component){
                    actionComponents.push(
                        React.createElement(action.component,{
                            key:'action_component_'+key,
                            module_item_id:this.props.module_item_id,
                            ref:'action_component_'+key,
                            container:this
                        })
                    )
                }

            }.bind(this))
        }

        if(props.customActions){
            props.customActions.forEach((action, index) => {
                if(action.component){
                    actionComponents.push(
                        React.createElement(action.component,{
                            key: 'action_component_' + action.config.action + '_' + action.config.id,
                            module_item_id: this.props.module_item_id,
                            ref: 'action_component_' + action.config.action + '_' + action.config.id,
                            container: this
                        })
                    )
                }
            });
        }

        var bulkActionClasses = "btn-group grid-bulk-action";

        if(state.selected.size > 1){
            bulkActionClasses += " bulk-action-multi-selection";
        } else if(state.selected.size == 1) {
            bulkActionClasses += " bulk-action-single-selection";
        } else if(state.selected.size == 0) {
            bulkActionClasses += " bulk-action-no-selection";
        }

        var bulkActionDropdown = (hasBulkActions && state.selected.size > 0 ?
                <div className={bulkActionClasses}>
                    <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span>Actions</span>
                    </button>
                    <div className="dropdown-menu">
                        {props.showBulkEdit ? <a method={"by_ids"} onClick={this.showBulkEditOptions.bind(this)} className="dropdown-item">{'Bulk Edit' + (state.selected.size?' ('+state.selected.size+')':'')}</a> : undefined}
                        {props.custom_print_action_url ? <a onClick={this.customPrintActionPDF.bind(this)} className="dropdown-item">{props.custom_print_action_name + (state.selected.size?' ('+state.selected.size+')':'')}</a> : undefined}
                        {props.export_pdf_url ? <a onClick={this.exportPDF.bind(this)} className="dropdown-item">{'Export for Print' + (state.selected.size?' ('+state.selected.size+')':'')}</a> : undefined}
                        {props.export_pdf_url ? <a onClick={this.downloadPDF.bind(this)} className="dropdown-item">{'Export to PDF' + (state.selected.size?' ('+state.selected.size+')':'')}</a> : undefined}
                        {props.export_csv_url ? <a onClick={this.exportCSV.bind(this)} className="dropdown-item">{'Export to CSV' + (state.selected.size?' ('+state.selected.size+')':'')}</a> : undefined}
                        {props.showSendMessage && props.personIdPath ? <a onClick={this.sendMessage.bind(this)} className="dropdown-item">{'Send Message' + (this.getTotalSelectedPersonIds()?' ('+this.getTotalSelectedPersonIds()+')':'')}</a> : undefined}
                        {props.showMailchimpIntegration && props.personIdPath ? <a method="by_ids" onClick={this.showMailchimpLists.bind(this)}
                                                                                   className="dropdown-item">{'Export to Mailchimp' + (this.getTotalSelectedPersonIds() ? ' (' + this.getTotalSelectedPersonIds() + ')' : '')}</a> : undefined}
                        {props.delete_url && canBulkDelete ? <a onClick={this.deleteRecord.bind(this)} className="dropdown-item">{'Delete' + (state.selected.size?' ('+state.selected.size+')':'')}</a> : undefined}
                        {bulkActions}
                    </div>
                </div>
                :undefined
        );

        var aggregates = undefined;

        if(props.aggregates.length && state.aggregateData){
            aggregates = [];
            state.aggregates.forEach(function(aggregate){
                aggregates.push(
                    <ReactModuleAggregate
                        key={aggregate['ModuleConfigGridAggregate'].id}
                        aggregate={aggregate}
                        value={me.getAggregateValue(aggregate['ModuleConfigGridAggregate'].id)}
                    />
                )
            })
        }

        // If new actions are added, "Export" label can be changed to something general.
        var globalActionDropdown = ((props.export_current_csv_url || props.export_all_csv_url)?
                <div className="btn-group grid-global-action">
                    <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span>Export</span>
                    </button>
                    <div className="dropdown-menu">
                        {props.export_current_csv_url?<a onClick={this.exportCurrentCSV.bind(this)} className="dropdown-item">CSV</a>:undefined}
                        {props.export_all_csv_url?<a onClick={this.exportAllToCSV.bind(this)} className="dropdown-item">Export All to CSV</a>:undefined}
                        {/*TODO: Enable bulk edit for this context menu using batch processing*/}
                        {false ? <a onClick={this.showBulkEditOptions.bind(this)} className="dropdown-item">Bulk
                            Edit</a> : undefined}
                    {props.showMailchimpIntegration ?
                            <a method="by_filters" onClick={this.showMailchimpLists.bind(this)} className="dropdown-item">Export All to
                                Mailchimp</a> : undefined}
                    </div>
                </div>
                :undefined
        );

        var toolComponents = [];
        var toolCount = 0;
        if(props.tools){
            var keys = Object.keys(props.tools);
            keys.forEach(function(key){
                toolCount++;
                if(props.tools[key]['component']){
                    var toolCmp = props.tools[key]['component'];
                    var toolProps = {
                        key:"tool_"+key,
                        module_item_id:props.module_item_id,
                        record_url:props.record_url,
                        ref:"tool_"+key
                    }
                    if(typeof toolCmp =='object'){
                        toolComponents.push(React.createElement(toolCmp.className,$.extend(toolProps,toolCmp.props)));
                    }else if(typeof toolCmp =='function'){
                        toolComponents.push(React.createElement(toolCmp,toolProps));
                    }
                }
            })
        }

        var createComponent = undefined;
        if(props.createComponent){
            var createComponentProps = {
                key:'create_record',
                module_item_id:this.props.module_item_id,
                ref:'create_record',
                record_url:props.record_url,
                moduleSettings:props.moduleSettings,
                container:this
            };
            if(typeof props.createComponent =='string'){
                createComponent = React.createElement(eval(props.createComponent),createComponentProps)
            }else if(typeof props.createComponent =='object'){
                var className = props.createComponent.className;
                createComponent = React.createElement(className,$.extend(createComponentProps,props.createComponent.props))
            }
        }

        var customComponents = [];
        if(state.customComponents){
            state.customComponents.forEach(function(item){
                customComponents.push(
                    React.createElement(item.className,{
                        key:item.key,
                        module_item_id:this.props.module_item_id,
                        ref:item.ref,
                        record_url:props.record_url,
                        container:this,
                        moduleSettings: this.props.moduleSettings
                    })
                )
            }.bind(this))
        }

        var customFiltersTitle = undefined;
        if(this.state.customFilter){
            customFiltersTitle = (
                <div className="grid-custom-filters-title">
                    Viewing transactions {this.state.customFilter.text.replace('From', 'from')}
                    <a href="#" onClick={preventDef(this.removeCustomFilter.bind(this))}></a>
                </div>
            );
        }

        var headerButtons = [];
        if(this.props.headerButtons){
            this.props.headerButtons.forEach(function (item, key) {
                headerButtons.push(
                    React.createElement(
                        'a',
                        { onClick: item.handler, className: 'btn btn-primary custom-button', role: 'button', key: 'header-button-'+key },
                        item.text
                    )
                );
            });
        }

        var footerButtons = [];
        if(this.props.footerButtons){
            this.props.footerButtons.forEach(function (item, key) {
                footerButtons.push(
                    React.createElement(
                        'a',
                        { onClick: item.handler, className: 'btn btn-primary custom-button', role: 'button', key: 'footer-button-'+key },
                        item.text
                    )
                );
            });
        }

        return (
            <ReactIntl.IntlProvider locale="en">
                <div className="ss-grid" ref={this.gridRootRef}>
                    {this.state.loading?<div className="loading-mask"></div>:undefined}
                    {bulkActionComponents}
                    {actionComponents}
                    <ReactSendMessage ref="send_message"
                                      showSendMessageEmailOverride={this.props.showSendMessageEmailOverride}
                    />
                    {this.props.showBulkEdit && Boolean(window.ReactBulkEdit) ?
                        <ReactBulkEdit ref="bulk_edit_ref" reloadGrid={this.load.bind(this)}/> : undefined}
                {this.props.showMailchimpIntegration ? <ReactMailchimpList ref="mailchimp_list"/> : undefined}
                    {props.editComponent ?
                        React.createElement(props.editComponent,{
                            key:'edit_record',
                            module_item_id:this.props.module_item_id,
                            ref:'edit_record',
                            container:this
                        }):
                        undefined}
                    {createComponent}
                    {toolComponents}
                    {customComponents}
                    <div className="grid-buttons text-right">
                        {props.mapView ?
                            <span>
                            <a onClick={this.toggleMap.bind(this)} className="btn btn-primary toggle-map show-map" role="button">Show Map</a>
                            <a onClick={this.toggleMap.bind(this)} className="btn btn-primary toggle-map hide-map hidden" role="button">Show Grid</a>
                        </span> : undefined}
                        {props.showFilters ?
                            <span>
                        <a onClick={this.toggleFilters.bind(this)} className="btn btn-primary toggle-filters show-filters" role="button">Show Filters</a>
                        <a onClick={this.toggleFilters.bind(this)} className="btn btn-primary toggle-filters hide-filters hidden" role="button">Hide Filters</a>
                        </span>
                            : undefined}
                        {createComponent ? <a onClick={this.createRecord.bind(this)} className="btn btn-primary create-record" role="button">
                            {props.newRecordTitle?props.newRecordTitle:'Create Record'}
                        </a> : undefined}
                        {headerButtons}
                    </div>
                    <div className="grid-filters">
                        <div className="available-columns-holder">
                            <h3 className="grid-filters-label available-columns-label">Available Columns</h3>
                            <div className="available-columns-checkboxes">
                                {avlCols}
                                <div className="clearfix"></div>
                            </div>
                        </div>
                        {filters.length ?
                            <div className="filter-by-holder">
                                <h3 className="grid-filters-label available-filters-label">
                                    Filters <a href="#" onClick={preventDef(this.clearFilters.bind(this))}><i/><span> Clear all</span></a>
                                    <a href="#"
                                       onClick={preventDef(this.resetView.bind(this))}><i/><span> Reset all</span></a>
                                    {customFilter}
                                    {savedViews}
                                </h3>
                                {filters}
                            </div>
                            : undefined}
                    </div>

                    {props.mapView ?
                    <CrmMap ref="map_view" mapViewActions={this.props.mapViewActions} columns={this.state.columns} requestParams={this.requestParams} module_item_id={props.module_item_id} getURLForColumn={this.getURLForColumn.bind(this)} getFiltersValues={this.getFiltersValues.bind(this)} grid={this}/>
                        : undefined}

                    <div className={"grid-holder " + (props.showColumnLabels?"show":"hide")+"-column-labels " +
                    (props.showColumnHeaders?"show":"hide")+"-column-headers"}>
                        {customFiltersTitle}
                        {!props.showColumnHeaders || props.showSort || props.showSearch ?
                            <div className="grid-header-holder">
                                <div className="grid-header-inner">
                                    {!props.showColumnHeaders && hasBulkActions && rows.length ?
                                        <div className="checkbox-holder select-all">
                                            <label className="c-input c-checkbox">
                                                <input
                                                    onChange={this.selectAll.bind(this)}
                                                    type="checkbox"
                                                />
                                                <span className="c-indicator"/>
                                                <span className="c-label"/>
                                            </label>
                                        </div>
                                        : undefined}

                                    {props.showSort ?
                                        <div className="sort-by-holder">
                                            <label className="sort-by-label inline">Sort By</label>

                                            <div className="btn-group grid-sort-by">
                                                <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <span>{state.sort_col?state.sort_col.get('ModuleConfigGridColumn').get('label'):'Select'}</span>
                                                </button>
                                                <div className="dropdown-menu">
                                                    {sortCols}
                                                </div>
                                            </div>

                                            <a onClick={this.toggleSortDir.bind(this)} className="btn btn-primary grid-sort-direction" role="button">
                                                <i className={'icon-up'+(state.sort_dir=='ASC'?'':' hidden')}/>
                                                <i className={'icon-down'+(state.sort_dir=='DESC'?'':' hidden')}/>
                                            </a>
                                        </div>
                                        : undefined}

                                    {bulkActionDropdown}

                                    {globalActionDropdown}

                                    {props.showSearch ?
                                        <div className="grid-search-holder input-search-holder pull-right">
                                            <input
                                                onKeyUp={this.search.bind(this)}
                                                type="text" placeholder="Search"
                                                ref="search_field"
                                            />
                                            <i className="clear" onClick={this.clearSearch.bind(this)}/>
                                        </div>
                                        : undefined}
                                    <div className="clearfix"></div>
                                </div>
                            </div>
                            : undefined}
                        <div className={"grid-rows grid-tools-"+toolCount} >
                            {props.showColumnHeaders ?
                                <div className={'grid-row grid-heading'+(state.colsToShow<hideableCols?' has-pushed-cols':'')
                                +(hasBulkActions?' with-bulk-actions':' without-bulk-actions')}
                                >
                                    {hasBulkActions ?
                                        <div className="grid-col grid-col-checkbox">
                                            <label className="c-input c-checkbox">
                                                <input
                                                    onChange={this.selectAll.bind(this)}
                                                    type="checkbox"
                                                />
                                                <span className="c-indicator"/>
                                                <span className="c-label"/>
                                            </label>
                                        </div>
                                        :undefined}
                                    <div className="grid-col grid-col-toggle">
                                        <i className="toggle-icon icon-down"/>
                                        <i className="toggle-icon icon-up"/>
                                    </div>
                                    {colHeaders}
                                    <div className="grid-col grid-col-actions"></div>
                                    <div className="clearfix"></div>
                                </div> : undefined }
                            {rows.length > 0 ? rows : <div className="grid-empty-result">
                                <h4>There are no items to display</h4>
                                <h6>Try making a different selection in the filters panel above.</h6>
                            </div>}
                        </div>
                        <div className="grid-footer-holder">
                            <div className="grid-footer-inner">
                                <div className="num-pages-holder">
                                    <label className="num-pages-label inline">View</label>

                                    <div className="btn-group grid-num-pages">
                                        <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <span>{state.limit}</span>
                                        </button>
                                        <div className="dropdown-menu">
                                            <a onClick={this.changeLimit.bind(this)} className="dropdown-item">25</a>
                                            <a onClick={this.changeLimit.bind(this)} className="dropdown-item">50</a>
                                            <a onClick={this.changeLimit.bind(this)} className="dropdown-item">100</a>
                                            <a onClick={this.changeLimit.bind(this)} className="dropdown-item">150</a>
                                            <a onClick={this.changeLimit.bind(this)} className="dropdown-item">200</a>
                                        </div>
                                    </div>
                                </div>

                                {bulkActionDropdown}

                                {aggregates?
                                    <div className="grid-aggregates-holder">
                                        {aggregates}
                                    </div>
                                :undefined}

                                <div className="grid-paging-holder pull-right">
                                    <label className="grid-paging-info inline">{Math.min(state.limit*(page-1)+1, state.total)}-{Math.min(state.limit*page, state.total)} of {state.total}</label>
                                    <a
                                        onClick={this.prev.bind(this)}
                                        className={'btn btn-primary grid-paging-prev' + (this.hasPrev(state.limit, state.total)?'':' disabled')}
                                        role="button">
                                        <i className="icon-left"/>
                                    </a>
                                    <a
                                        onClick={this.next.bind(this)}
                                        className={'btn btn-primary grid-paging-next' + (this.hasNext(state.limit, state.total)?'':' disabled')}
                                        role="button">
                                        <i className="icon-right"/>
                                    </a>
                                </div>
                                <div className="grid-buttons grid-footer-buttons">
                                    {footerButtons}
                                </div>
                                <div className="clearfix"></div>
                            </div>
                        </div>
                        <div className="clearfix"></div>
                    </div>
                </div>
            </ReactIntl.IntlProvider>
        );
    }
}

ReactGrid.propTypes = {
    module_item_id: PropTypes.number.isRequired,
    module_item_token: PropTypes.string,
    columns: PropTypes.array.isRequired,
    filters: PropTypes.array.isRequired,
    aggregates: PropTypes.array.isRequired,
    // idPath is the path where the record id exists, given as an array of strings as described here:
    // https://facebook.github.io/immutable-js/docs/#/Iterable/getIn
    // e.g. for a Person record it would be: ['Person', 'id']
    idPath: PropTypes.arrayOf(PropTypes.string).isRequired,
    personIdPath: PropTypes.arrayOf(PropTypes.string),
    createComponent: PropTypes.any,
    delete_url: PropTypes.string,
    record_url: PropTypes.string,
    // links represents an object with (key - url pattern) records representing (link_identifier - array with url and keys to replace in url)
    // if you want to have links on the columns this is required
    // e.g. {donor: ['/user?person={0}', ['Person', 'id']}
    links: PropTypes.object,
    // linkColumn can be given to specify which column will use the record_url (0-based)
    // DEPRECATED: use the 'links' and 'link_identifier' in each column instead
    linkColumn: PropTypes.number,
    export_pdf_url: PropTypes.string,
    custom_print_action_name: PropTypes.string,
    custom_print_action_url: PropTypes.string,
    export_csv_url: PropTypes.string,
    export_current_csv_url: PropTypes.string,
    export_all_csv_url: PropTypes.string,
    load_url: PropTypes.string.isRequired,
    urlParams: PropTypes.object,
    showColumnHeaders: PropTypes.bool,
    showColumnLabels: PropTypes.bool,
    showMailchimpIntegration: PropTypes.bool,
    showBulkEdit: PropTypes.bool,
    showFilters: PropTypes.bool,
    showSort: PropTypes.bool,
    showSearch: PropTypes.bool,
    searchParam: PropTypes.string,
    showSendMessage: PropTypes.bool,
    showSendMessageEmailOverride: PropTypes.bool,
    sendMessageSubjectPath: PropTypes.array,
    tools: PropTypes.object,
    alwaysHiddenColumns: PropTypes.array,
    newRecordTitle: PropTypes.string,
    gridType: PropTypes.string,
    columnRenderers: PropTypes.object,
    labelRenderers: PropTypes.object,
    limit: PropTypes.number,
    headerButtons: PropTypes.array,
    // actions is an object that contains custom actions given at init.
    // For usage see packages\components\SitePlanner\View\modules\ContentGrid\default.ctp
    // and packages\components\People\View\modules\Crm\default.ctp.
    actions: PropTypes.object,
    customActions: PropTypes.array,
    moduleSettings: PropTypes.any,
    getRowCls: PropTypes.any,
    mapView: PropTypes.bool
};

ReactGrid.defaultProps = {
    links: {},
    linkColumn: 0,
    showSendMessage: true,
    showSendMessageEmailOverride: false,
    alwaysHiddenColumns: [],
    renderHtmlColumns: [],
    columnRenderers: {},
    labelRenderers: {},
    showMailchimpIntegration: false,
    showBulkEdit: false,
    searchParam: 'search',
    export_current_csv_url: undefined,
    export_all_csv_url: undefined,
    aggregates: [],
};

class ReactFormatterBoolean extends React.Component {

    constructor(props) {
        super(props);
    }

    render(){
        return (
            <span>
                {this.props.value ? this.props.trueText : this.props.falseText}
            </span>
        )
    }
}

ReactFormatterBoolean.defaultProps = {
    value: false,
    trueText: 'Yes',
    falseText: 'No'
};

class ReactFormatterLink extends React.Component {

    constructor(props) {
        super(props);
    }

    render(){
        var props = this.props;
        var columnAlias = props.column.alias;
        var record = props.record.toJS();

        var model = columnAlias.split(".")[0];
        var link = props.value;
        var text = "";
        var target = "_blank";


        var linkObject = record[model];

        if(linkObject){
            link = linkObject.url;
            text = linkObject.text;
            target = linkObject.target;
        }

        if(!text){
            text = link;
        }

        return (
            <a href={link} target={target}>{text}</a>
        )
    }
}

ReactFormatterLink.defaultProps = {};

class ReactFormatterImage extends React.Component {

    constructor(props) {
        super(props);
    }

    render(){
        var path = SS.com.FileManager.frontend.util.Resizer.getResizedPath(this.props.value,120,100,null,true);
        var alt = this.props.record.getIn(['Person','fullname']);

        return (
            <img src={path} alt={alt}/>
        )
    }
}

ReactFormatterImage.defaultProps = {};

class SavedViews extends React.Component{

    constructor(props){
        super(props);
        this.initial = true;
        this.state = {
            isCreatingView: false,
            views: []
        };
        ReactGridDialogMixin._composite(this);
    }

    createView(e){
        this.setState({
            isCreatingView:true
        },function(){
            this.refs.viewText.focus();
        }.bind(this))
    }

    changeView(id){
        var views = this.state.views;

        views.forEach(function(view){
            if(view.id==id){
                this.props.grid.applyViewData(view.settings);
                view.default = 1;
            }else{
                view.default = 0;
            }
        }.bind(this));

        $.ajax({
            url: SS.route('Modules','ModuleConfigGridViews','setDefaultView', null),
            data: {
                id:id
            },
            dataType: 'json',
            method:'POST',
            cache: false
        });
    }

    componentDidMount() {
        var timer = 0;
        this.getViews();
    }

    componentDidUpdate(){
        var menu = $(ReactDOM.findDOMNode(this.refs.ddmain));
        this.menu = menu;

        if (!this.menuClickBinded) {
            console.log('menu binded!');
            menu.on("click.bs.dropdown", (e) => {
                this.onMenuClick(e)
            });
            this.menuClickBinded = true;
        }
    }

    getViews() {
        this.setLoading(true);
        $.ajax({
            url: SS.route('Modules','ModuleConfigGridViews','getViews', null),
            data: {
                moduleItemId:this.props.module_item_id
            },
            dataType: 'json',
            cache: false,
            success: function(data) {
                if(this.initial){
                    this.initial = false;
                    var defaultView = null;
                    data.views.forEach(function(view){
                        if(view.default){
                            defaultView = view;
                        }
                    });

                    this.props.grid.loadDefaultView(defaultView?defaultView.settings:null);
                }


                this.setState({
                    views:data.views,
                    loading:false
                })
            }.bind(this),
            error: function(xhr, status, err) {
                alert(xhr.responseText);
            }
        });
    }

    deleteView(viewId){
        var me = this;
        var title = 'Delete confirmation';
        var text = 'Are you sure you want to delete this?';
        var customButtons =  {
            Remove: function(e) {
                e.preventDefault();
                e.stopPropagation();

                me.setLoading(true);
                $.ajax({
                    url: SS.route('Modules','ModuleConfigGridViews','deleteView', null),
                    data: {
                        id:viewId
                    },
                    method:'POST',
                    dataType: 'json',
                    cache: false,
                    success: function(data) {
                        me.setLoading(false);
                        me.getViews();
                    }.bind(this),
                    error: function(xhr, status, err) {
                        alert(xhr.responseText);
                    }
                });

                $(this).dialog("close");
            },
            Cancel: function(e) {
                e.preventDefault();
                e.stopPropagation();

                $(this).dialog("close");
            }
        };

        this.openDialog(title, text, customButtons);


    }

    saveViewKey(e){
        if(e.key == 'Enter'){
            this.saveView();
        }
    }

    setLoading(loading){
        this.setState({
            loading:loading
        })
    }

    clearView(skipGrid){
        this.setLoading(true);
        $.ajax({
            url: SS.route('Modules','ModuleConfigGridViews','clearView', null),
            data: {
                moduleItemId:this.props.module_item_id
            },
            method:'POST',
            dataType: 'json',
            cache: false,
            success: function(data) {
                this.setLoading(false);
                this.getViews();
                if(!skipGrid){
                    this.props.grid.resetView();
                }

            }.bind(this),
            error: function(xhr, status, err) {
                alert(xhr.responseText);
            }
        });
    }

    saveView(e){
        var viewText = $(ReactDOM.findDOMNode(this.refs.viewText));
        if(viewText.val()) {
            var view = this.props.grid.getViewData();
            this.setLoading(true);
            $.ajax({
                url: SS.route('Modules','ModuleConfigGridViews','saveView', null),
                data: {
                    settings:JSON.stringify(view),
                    module_item_id:this.props.module_item_id,
                    title:viewText.val()
                },
                method:'POST',
                dataType: 'json',
                cache: false,
                success: function(data) {
                    this.setState({
                        isCreatingView:false,
                        loading:false
                    });
                    this.getViews();
                }.bind(this),
                error: function(xhr, status, err) {
                    alert(xhr.responseText);
                }
            });
        }
    }

    onMenuClick(e){
        if(this.menu.hasClass('open')){
            if($(e.target).hasClass("create-view-btn")){
                e.stopPropagation();
                this.createView();
            }else if($(e.target).hasClass("save-view-btn")){
                e.stopPropagation();
                this.saveView();
            }else if($(e.target).hasClass("view-delete")){
                e.stopPropagation();
                this.deleteView($(e.target).data('viewid'));
            }
        }else{
            if(this.state.isCreatingView){
                this.setState({
                    isCreatingView:false
                })
            }
        }
    }

    render(){
        var savedViews = [];
        var defaultView = null;

        var state = this.state;

        if(!state.views.length){
            savedViews = [
                <div key="no-view" className='no-view'> No Saved Views </div>
            ]
        }else{
            state.views.forEach(function(view){
                if(view.default){
                    defaultView = view;
                }

                savedViews.push(
                    <div onClick={this.changeView.bind(this, view.id)}
                         key={view.id}
                         className="dropdown-item"
                    >
                        <span className="view-text">{view.title}</span>
                        <a className="view-delete" data-viewid={view.id}>Delete</a>
                    </div>
                )
            }.bind(this));
        }

        return(
            <div className="saved-view-holder">
                <label className="saved-views inline">Saved View</label>

                <div ref="ddmain" className={"btn-group grid-saved-view" + (defaultView?' active':'')}>
                    <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {defaultView?defaultView.title:'Select'}
                    </button>
                    {defaultView?<button className="btn btn-primary clear-view" onClick={this.clearView.bind(this)}><i></i></button>:''}
                    <div className="dropdown-menu dropdown-menu-right">
                        {this.state.loading?<div className="loading-mask"></div>:undefined}
                        {savedViews}
                        <div className="create-view">
                            {state.isCreatingView?
                                <div className="input-group">
                                    <input type="text" ref="viewText" className="form-control" placeholder="View Name" onKeyPress={this.saveViewKey.bind(this)}/>
                                    <span className="input-group-btn">
                                        <button className="btn btn-primary save-view-btn" type="button" onClick={this.saveView.bind(this)}>Save</button>
                                    </span>
                                </div>:
                                <a className="create-view-btn" href="#" onClick={preventDef(this.createView.bind(this))}>+ Create a New Saved View</a>}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

SavedViews.defaultProps = {};

class ReactGridCustomAction {

    constructor(config) {
        this.pristineConfig = Object.assign({}, config);
        this.config = Object.assign({}, config);
        this.config.disabled = false;
        this.component = null;
        this.link = {
            url: false,
            target: '_self'
        }
    }

    getText() {
        return this.config.text;
    }

    allowBulk() {
        return this.config.allow_bulk;
    }

    isDisabled() {
        return this.config.disabled;
    }

    conditions(record) {
        return true;
    }

    onToggle(isOpen, record, gridComponent) {

    }

    handler(index, record, callback, options, event) {
        callback();
    }

    bulkHandler(index, records, callback, options, event) {
        callback();
    }

}

class ReactModuleAggregate extends React.Component {
    render() {
        var aggregate = this.props.aggregate['ModuleConfigGridAggregate'];
        var value = this.props.value;
        var formatted = this.props.aggregate.formatted;

        if (formatted) {
            var comp = formatted.component;
            var props = formatted.props ? formatted.props : {};

            value = React.createElement(eval(comp), $.extend(props, {
                value: value
            }));
        }

        return (
            <div className="grid-aggregate">
                <label className="grid-aggregate-label">
                    {aggregate.label}
                </label>
                <div className="grid-aggregate-value">
                    {value}
                </div>
            </div>
        );
    }
}

ReactModuleAggregate.propTypes = {
    aggregate: PropTypes.any,
    value: PropTypes.any
};